import React, { useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
import type { ReactElement } from 'react';

import { urlPrefix } from '@components/AppRouter/constants';
import { userStore } from '@stores/userStore';

import { routeConfig } from './routeConfig';
import { filterRoutes } from './routeConfig/utils';
import type { Route as IRoute } from './types';

function renderRoutes(routes: IRoute[]): ReactElement[] {
  const routeElements: ReactElement[] = [];

  routes.forEach((route, index) => {
    if (route.component && route.path) {
      routeElements.push(<Route exact key={route.path} path={route.path} component={route.component} />);
    } else if (route.redirectTo) {
      const path = `${route.redirectTo}-${index}`;
      routeElements.push(<Route exact path={path} render={() => <Redirect to={route.redirectTo} />} />);
    }
    if (route.routes) {
      renderRoutes(route.routes).forEach((childRoute) => routeElements.push(childRoute));
    }
  });

  return routeElements;
}

export const AppRouter = observer((): ReactElement => {
  const { user } = userStore;

  const config = useMemo(() => renderRoutes(filterRoutes({ routes: routeConfig.routes, user })), [user]);

  if (!user) return <></>;

  return (
    <Switch>
      {config}
      <Route path={urlPrefix}>
        <Redirect to={routeConfig.defaultRoute} />
      </Route>
    </Switch>
  );
});
